import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

function bannerBoxedOnScroll(){
	const bannersMedia = document.querySelectorAll('[data-name="banner-boxed--media"]');

	if ( bannersMedia.length > 0 ) {
		bannersMedia.forEach(media => {
			// Check if this element has twk-aos animation
			const hasTwkAos = media.hasAttribute('twk-aos');

			// Function to initialize the scroll animation
			const initScrollAnimation = () => {
				gsap.set(media, { clipPath: 'inset(0% 0% 10% 0%)' });

				gsap.fromTo(media,
					{ clipPath: 'inset(0% 0% 10% 0%)' },{
					clipPath: 'inset(0% 0% 0% 0%)',
					scrollTrigger: {
						trigger: media,
						start: 'top top',
						end: 'bottom top',
						scrub: 0.5,
					}
				});
			};

			if (hasTwkAos) {
				// Wait for the twk-aos animation to complete using MutationObserver
				const observer = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						if (mutation.type === 'attributes' && mutation.attributeName === 'twk-aos-status') {
							const status = media.getAttribute('twk-aos-status');
							if (status === 'animated') {
								// twk-aos animation is complete, now init scroll animation
								initScrollAnimation();
								observer.disconnect(); // Stop observing
							}
						}
					});
				});

				// Start observing the element for attribute changes
				observer.observe(media, {
					attributes: true,
					attributeFilter: ['twk-aos-status']
				});

				// Fallback: if status is already 'animated', init immediately
				if (media.getAttribute('twk-aos-status') === 'animated') {
					initScrollAnimation();
					observer.disconnect();
				}
			} else {
				// No twk-aos animation, init scroll animation immediately
				initScrollAnimation();
			}
		});
	}
}


function footerBigtext() {
	const container = document.querySelector("#lycee-svg");
	if (!container) return;

	const targets = Array.from(container.querySelectorAll(".rotateY-on-hover--target"));
	if (!targets.length) return;

	targets.forEach(tt => {
		tt.style.setProperty("--rotY", "180deg");
	});

	ScrollTrigger.create({
		trigger: container,
		start: "top bottom-=200px",
		once: true,
		onEnter: () => {
			gsap.fromTo(
				targets,
				{ "--rotY": "180deg" },
				{
					"--rotY": "0deg",
					duration: 0.28,
					ease: "power2.out",
					stagger: 0.18,
					onComplete: () => targets.forEach(t => t.style.removeProperty("--rotY"))
				}
			);
		}
	});
}



function animations(){
	bannerBoxedOnScroll()
	footerBigtext()
}

export default animations;